// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file google/rpc/error_details.proto (package google.rpc, syntax proto3)
/* eslint-disable */
import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Minimal vendored slice of google/rpc/error_details.proto — only the
 * `ErrorInfo` message (the structured-error detail the bay-session
 * FullSwingAuth handler attaches to its station-not-managed signal, DBF-1).
 *
 * The mobile client decodes this detail to read `reason` and decide whether to
 * fall back to the legacy partner-service login (StoreContextProvider
 * .fullSwingTokenLogin). It is the client half of the single-source-of-truth
 * coupling with the server constant `stationNotBaySessionManagedSignal`
 * (apps/platform-domain/bay-session/cmd/bay-session/fullswing_auth_handler.go).
 *
 * Regenerate with `buf generate` from the upstream google/rpc/error_details
 * proto if the well-known type is ever added to the buf workspace; the base64
 * descriptor below is the protoc-gen-es output for a 3-field ErrorInfo.
 */
export const file_google_rpc_error_details: GenFile = /*@__PURE__*/
  fileDesc("Ch5nb29nbGUvcnBjL2Vycm9yX2RldGFpbHMucHJvdG8SCmdvb2dsZS5ycGMikwEKCUVycm9ySW5mbxIOCgZyZWFzb24YASABKAkSDgoGZG9tYWluGAIgASgJEjUKCG1ldGFkYXRhGAMgAygLMiMuZ29vZ2xlLnJwYy5FcnJvckluZm8uTWV0YWRhdGFFbnRyeRovCg1NZXRhZGF0YUVudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAFiBnByb3RvMw");

/**
 * Describes the error and where it originated.
 *
 * @generated from message google.rpc.ErrorInfo
 */
export type ErrorInfo = Message<"google.rpc.ErrorInfo"> & {
  /**
   * The reason of the error. This is a constant value that identifies the
   * proximate cause of the error.
   *
   * @generated from field: string reason = 1;
   */
  reason: string;

  /**
   * The logical grouping to which the "reason" belongs.
   *
   * @generated from field: string domain = 2;
   */
  domain: string;

  /**
   * Additional structured details about this error.
   *
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message google.rpc.ErrorInfo.
 * Use `create(ErrorInfoSchema)` to create a new message.
 */
export const ErrorInfoSchema: GenMessage<ErrorInfo> = /*@__PURE__*/
  messageDesc(file_google_rpc_error_details, 0);
